import styled from 'styled-components';

const Tr = styled.tr`
  td.w-33 {
    width: ${100 / 3}%;
  }

  td.w-17 {
    width: ${100 / 6}%;
  }
`;

export default {
  Tr
};
